import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { eyeIcon, CloseEyeIcon } from '../../assets/icons';
import { InputTextarea } from 'primereact/inputtextarea'
import { useDispatch } from 'react-redux'
import { handleLoader } from 'redux/counterSlice'
import { getConfigDataByID, getConnectorsDropdownData, getConnectorsKeysData, loginConfig, saveConfig } from 'services/pdfUploadService'
import { toast } from 'react-toastify'
import CryptoJS from 'crypto-js';
import { Dropdown } from 'primereact/dropdown'
import SharePointConnector from './SharepointConnector'
import _ from 'lodash'

const AddUpdateLoginPDF = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userName = localStorage.getItem("username")

    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        trigger,
        clearErrors,
        watch,
        reset,
        formState: { errors },
    } = useForm<any>()

    const [showPassword, setShowPassword] = useState(false);
    const [connectorsList, setConnectorsList] = useState([]);
    const [selectedCity, setSelectedCity] = useState({ name: 'SFTP' });
    const [keys, setKeys] = useState([]);
    const [loginKeys, setLoginKeys] = useState([]);
    const [destinationPath, setDestinationPath] = useState("");

    const cities = [
        { name: 'SFTP', code: 'NY' },
        { name: 'SHAREPOINT', code: 'sharepoint' },
        { name: 'SALESFORCE', code: 'salesforce' }
    ];


    const getFormErrorMessage = (name: string) => {
        return (
            errors[name] && (
                <small className="p-error">{errors[name]?.message?.toString()}</small>
            )
        )
    }

    const secretKey = 'RONSFTPCONNECTOR';
    const iv = 'BBBBBBBBBBBBBBBB';
    // Function to encrypt the password
    const encryptPassword = (password: string) => {
        // Replace 'your-secret-key' with your own secret key
        // Encrypt the password using AES encryption with the secret key
        // const encryptedPassword = CryptoJS.AES.encrypt(password, secretKey).toString();
        // return encryptedPassword;
        const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.ECB
        });
        return encrypted.toString();
    };

    // Function to decrypt the password
    const decryptPassword = (encryptedPassword: string) => {
        // try {
        //     // Decrypt the password using AES decryption with the secret key
        //     const bytes = CryptoJS.AES.decrypt(encryptedPassword, secretKey);
        //     // Convert the bytes to a UTF-8 string
        //     const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);
        //     return decryptedPassword;
        // } catch (error: any) {
        //     console.error('Error decrypting password:', error.message);
        //     return null;
        // }

        try {
            const parsedKey = CryptoJS.enc.Utf8.parse(secretKey);

            // Decrypt using AES with ECB mode
            const decrypted = CryptoJS.AES.decrypt(encryptedPassword, parsedKey, {
                mode: CryptoJS.mode.ECB
            });
            // Convert decrypted data to UTF-8 string
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (error) {
            console.error('Error decrypting data:', error);
            return '';
        }
    };

    const getDataById = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getConfigDataByID(params.id as string);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            if(result?.source === "sftp_doc") {
                setSelectedCity({ name: 'SFTP' })
            } else {
                setSelectedCity({name: result?.connector_name})
            }
            getConnectorsKeys(result?.connector_name)
            const decryptedResult = { ...result };
            Object.keys(decryptedResult).forEach((key) => {
                if (key.includes('secret') || key.includes('password')) {
                    decryptedResult[key] = decryptPassword(decryptedResult[key]);
                }
            });
            reset(decryptedResult)
            dispatch(handleLoader(false));
            // setValue("username", result.username);
            // setValue("destination_path", result.destination_path);
            // setDestinationPath(result.destination_path);
            // setValue("hostname", result.hostname);
            // setValue("hosturl", result.hosturl);
            // const decryptedPassword = decryptPassword(result?.password);
            // setValue("password", decryptedPassword);
            // setValue("port", result.port);
            // setValue("remarks", result.remarks);
            // setValue("client_env", result.client_env);
            // setValue("source_path", result.source_path);
            // setValue("file_transfer_path", result.file_transfer_path);
            // setValue("unprocess_file_path", result.unprocess_file_path);
            // setValue("process_file_path", result.process_file_path);
            // setValue("error_file_path", result.error_file_path);
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    // Watch the 'destination_path' field and log its value
    const watchedValue = watch('destination_path');


    const onSubmit = async (data: any) => {
        data.password = encryptPassword(data.password);
        if (params.id === "add") {
            data.source = "sftp_doc"
            data.file_extension = [".pdf", ".doc", ".docx", ".csv", ".txt", ".xlsx"]
            // data.file_extension = [".mp4",".mp3",".wav"] // for voice
            // data.source = params["*"] === "pdf-upload" ? "sftp_doc" : "sftp_voice"
            data.created_by = userName
            dispatch(handleLoader(true));
            try {
                const { result, error } = await saveConfig(data);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                navigate("/admin/pdf-upload")
            } catch (error: any) {
                dispatch(handleLoader(false));
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            }
        } else {
            delete data.created_by
            data.source = "sftp_doc";
            data.file_extension = [".pdf", ".doc", ".docx", ".csv", ".txt", ".xlsx"]
            // data.file_extension = [".mp4",".mp3",".wav"] // for voice
            // data.source = "pdf-upload" ? "sftp_doc" : "sftp_voice";
            data.objectid = params.id;
            // delete data.client_env
            dispatch(handleLoader(true));
            data.updated_by = userName
            try {
                const { result, error } = await saveConfig(data);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                navigate("/admin/pdf-upload")
            } catch (error: any) {
                dispatch(handleLoader(false));
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            }
        }
    }

    const getDropdownData = async () => {
        dispatch(handleLoader(true));
        try {
          const { result, error } = await getConnectorsDropdownData();
          if (error) {
            throw error
          }
          if (result?.error) {
            throw result.error
          }
          dispatch(handleLoader(false));
          const dropdownItems = result?.get_dropdown_keys.map((key: string) => {
            return {
              name: key,
            };
          });
          setConnectorsList(dropdownItems);
        } catch (error: any) {
          dispatch(handleLoader(false));
          toast.error(error, {
            style: {
                backgroundColor: '#F1F1F1', // Grey background
            }
        });
        }
    }

    const getConnectorsKeys = async (data: string) => {
        dispatch(handleLoader(true));
        try {
          const { result, error } = await getConnectorsKeysData(data);
          if (error) {
            throw error
          }
          if (result?.error) {
            throw result.error
          }
          dispatch(handleLoader(false));
          let valuesToRemove = ["objectid", "connector_name", "file_extension", "login_username", "created_by", "updated_by"];
          const modifiedKeys: any = _.without(result?.get_keys_for_update, ...valuesToRemove);
          setKeys(modifiedKeys);
          setLoginKeys(result?.get_keys_for_login)
        } catch (error: any) {
          dispatch(handleLoader(false));
          toast.error(error, {
            style: {
                backgroundColor: '#F1F1F1', // Grey background
            }
        });
        }
    }

    const handleChangeConnector = (value: any) => {
        const modifiedValue = value?.name === "SFTP"? "sftp_doc" : value?.name
        getConnectorsKeys(modifiedValue)
    }

    useEffect(() => {
        getDropdownData()
        if (params.id === "add") {
            getConnectorsKeys(selectedCity?.name)
        }
        if (params.id !== "add") {
            getDataById();
        }
    }, [])

    const header = () => {
        if (params.id === "add") {
            return "Add Configuration"
        } else if (params.id === "login") {
            return "Login"
        } else {
            return "Edit Configuration"
        }
    }

    // Function to clear validation errors on change
    const clearValidationErrorsOnChange = (fieldName: string) => {
        clearErrors(fieldName);
    };

    const handleTest = async () => {
        let isValid: boolean = false;
        isValid = await trigger(['hosturl', 'port', 'username', 'password']);
        if (isValid) {
            const temp = {} as { hosturl: string, port: string, username: string, password: string };
            temp.hosturl = getValues("hosturl");
            temp.port = getValues("port");
            temp.username = getValues("username");
            temp.password = encryptPassword(getValues("password"));
            dispatch(handleLoader(true));
            try {
                const { result, error } = await loginConfig(temp);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                // navigate("/file-config");
            } catch (error: any) {
                dispatch(handleLoader(false));
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            }
        }
    }

    const isPasswordRequired = params.id !== "login" ? true : false;
    const passwordValidation = (val: string) => {
        return isPasswordRequired
            ? {
                required: {
                    value: true,
                    message: `${val} is required`,
                },
            }
            : {}
    };
    return (
        <main className="content-wrapper">
            <div className="container-fluid p-4 change-password-section">
                <h4 className="mb-4">
                    {header()}
                </h4>
                <div className="card">
                    <div className="card-body">
                        <div className="row gx-4">
                            <div className="mb-4 col-md-6">
                                <label htmlFor="city" className="form-label">
                                    Data Source Type
                                </label>
                                <div>
                                    {/* <Dropdown value={selectedCity} onChange={(e) => {setSelectedCity(e.value), handleChangeConnector(e.value)}} disabled={params.id !== "add" ? true : false} options={connectorsList} optionLabel="name" className="w-100" checkmark={true} /> */}
                                </div>
                            </div>
                        </div>
                        {selectedCity.name === "SFTP"
                        ? <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row gx-4">
                                <div className="mb-4 col-md-6">
                                    <label htmlFor="host url" className="form-label">
                                        Host URL<span className="text-red-600">*</span>
                                    </label>
                                    <div>
                                        <InputText
                                            className="form-control"
                                            {...register("hosturl", {
                                                required: {
                                                    value: true,
                                                    message: "Host URL is required",
                                                },
                                            })}
                                            onChange={() => clearValidationErrorsOnChange('hosturl')}
                                            placeholder="Host URL"
                                        />
                                    </div>
                                    {getFormErrorMessage("hosturl")}
                                </div>
                                <div className="mb-4 col-md-6">
                                    <label htmlFor="port" className="form-label">
                                        Port<span className="text-red-600">*</span>
                                    </label>
                                    <div>
                                        <InputText
                                            type='number'
                                            className="form-control"
                                            {...register("port", {
                                                required: {
                                                    value: true,
                                                    message: "Port is required",
                                                },
                                            })}
                                            placeholder="Port"
                                            onChange={() => clearValidationErrorsOnChange('port')}
                                        />
                                    </div>
                                    {getFormErrorMessage("port")}
                                </div>
                            </div>
                            <div className="row gx-4">
                                <div className="mb-4 col-md-6">
                                    <label htmlFor="user name" className="form-label">
                                        Username<span className="text-red-600">*</span>
                                    </label>
                                    <div>
                                        <InputText
                                            className="form-control"
                                            {...register("username", {
                                                required: {
                                                    value: true,
                                                    message: "Username is required",
                                                },
                                            })}
                                            placeholder="Username"
                                            onChange={() => clearValidationErrorsOnChange('username')}
                                            autoComplete="new-password"
                                        />
                                    </div>
                                    {getFormErrorMessage("username")}
                                </div>
                                <div className="mb-2 mb-md-4 col-md-6">
                                    <label htmlFor="password" className="form-label">
                                        Password<span className="text-red-600">*</span>
                                    </label>
                                    <div className='d-flex position-relative'>
                                        <InputText
                                            className="form-control "
                                            type={showPassword ? "text" : "password"}
                                            {...register("password", {
                                                required: {
                                                    value: true,
                                                    message: `Password is required`,
                                                },
                                            })}
                                            placeholder="Enter your Password"
                                            autoComplete="new-password"
                                            onChange={() => clearValidationErrorsOnChange('password')}
                                        />
                                        <span className={`password-toggle2 c-pointer `} onClick={() => setShowPassword(!showPassword)}>
                                            {!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                                <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                            }
                                        </span>
                                    </div>
                                    {getFormErrorMessage("password")}
                                </div>
                            </div>
                            {params.id !== "login" &&
                                <>
                                    <div className="row gx-4">
                                        <div className="mb-4 col-md-6">
                                            <label htmlFor="host" className="form-label">
                                                Host Name<span className="text-red-600">*</span>
                                            </label>
                                            <div>
                                                <InputText
                                                    className="form-control"
                                                    {...register("hostname", passwordValidation("Host Name"))}
                                                    placeholder="Host Name"
                                                />
                                            </div>
                                            {getFormErrorMessage("hostname")}
                                        </div>
                                        <div className="mb-4 col-md-6">
                                            <label htmlFor="ENV" className="form-label">
                                                ENV<span className="text-red-600">*</span>
                                            </label>
                                            <div>
                                                <InputText
                                                    className="form-control"
                                                    {...register("client_env", passwordValidation("ENV"))}
                                                    placeholder="ENV"
                                                />
                                            </div>
                                            {getFormErrorMessage("client_env")}
                                        </div>
                                    </div>
                                    <div className="row gx-4">
                                        <div className="mb-4 col-md-6">
                                            <label htmlFor="source_path" className="form-label">
                                                Source Path<span className="text-red-600">*</span>
                                            </label>
                                            <div>
                                                <InputText
                                                    className="form-control"
                                                    {...register("source_path", passwordValidation("Source Path"))}
                                                    placeholder="Source Path"
                                                />
                                            </div>
                                            {getFormErrorMessage("source_path")}
                                        </div>
                                        <div className="mb-4 col-md-6">
                                            <label htmlFor="file_transfer_path" className="form-label">
                                                Source File Transfer Path<span className="text-red-600">*</span>
                                            </label>
                                            <div>
                                                <InputText
                                                    className="form-control"
                                                    {...register("file_transfer_path", passwordValidation("Source File Transfer Path"))}
                                                    placeholder="Source File Transfer Path"
                                                />
                                            </div>
                                            {getFormErrorMessage("file_transfer_path")}
                                        </div>
                                    </div>
                                    <div className="row gx-4">
                                        <div className="mb-4 col-md-6">
                                            <label htmlFor="host" className="form-label">
                                                Destination Path<span className="text-red-600">*</span>
                                            </label>
                                            <div>
                                                <InputText
                                                    className="form-control"
                                                    {...register("destination_path", passwordValidation("Destination Path"))}
                                                    placeholder="Destination Path"
                                                />
                                            </div>
                                            {getFormErrorMessage("destination_path")}
                                        </div>
                                        <div className="mb-4 col-md-6">
                                            <label htmlFor="Process File Path" className="form-label">
                                                Processed file path<span className="text-red-600">*</span>
                                            </label>
                                            <div className="wrapper w-full">
                                                <span className="sufix">{watchedValue}</span>
                                                <InputText
                                                    className="form-control w-full"
                                                    {...register("process_file_path", passwordValidation("Processed File Path"))}
                                                    placeholder="Processed File Path"
                                                />
                                            </div>
                                            {getFormErrorMessage("process_file_path")}
                                        </div>
                                    </div>
                                    <div className="row gx-4">
                                        <div className="mb-4 col-md-6">
                                            <label htmlFor="Unprocess File Path" className="form-label">
                                                Unprocessed File Path<span className="text-red-600">*</span>
                                            </label>
                                            <div className="wrapper w-full">
                                                <span className="sufix">{watchedValue}</span>
                                                <InputText
                                                    className="form-control w-full"
                                                    {...register("unprocess_file_path", passwordValidation("Unprocessed File Path"))}
                                                    placeholder="Unprocessed File Path"
                                                />
                                            </div>
                                            {getFormErrorMessage("unprocess_file_path")}
                                        </div>
                                        <div className="mb-4 col-md-6">
                                            <label htmlFor="Error File Path" className="form-label">
                                                Error file path<span className="text-red-600">*</span>
                                            </label>
                                            <div className="wrapper w-full">
                                                <span className="sufix">{watchedValue}</span>
                                                <InputText
                                                    className="form-control w-full"
                                                    {...register("error_file_path", passwordValidation("Error File Path"))}
                                                    placeholder="Error File Path"
                                                />
                                            </div>
                                            {getFormErrorMessage("error_file_path")}
                                        </div>
                                        {/* <div className="mb-4 col-md-6">
                                            <label htmlFor="Error File Path" className="form-label">
                                                Error file path<span className="text-red-600">*</span>
                                            </label>
                                            <div>
                                                <InputText
                                                    className="form-control"
                                                    {...register("error_file_path", passwordValidation("Error File Path"))}
                                                    placeholder="Error File Path"
                                                />
                                            </div>
                                            {getFormErrorMessage("error_file_path")}
                                        </div> */}
                                    </div>
                                    <div className="row gx-4">
                                        <div className="mb-4 col-md-12">
                                            <label htmlFor="remarks" className="form-label">
                                                Remark
                                            </label>
                                            <InputTextarea rows={6} className="form-control p-inputtext-lg"
                                                {...register("remarks")}
                                                placeholder="Add remark here..."
                                            />
                                            {/* {getFormErrorMessage("remark")} */}
                                        </div>
                                    </div>
                                </>
                            }
                            <div className="row gx-4">
                                {/* <div className="mb-2 col-md-6">
                  <label htmlFor="user name" className="form-label">
                  user name<span className="text-red-600">*</span>
                  </label>
                  <div>
                    <InputText
                      className="form-control"
                      type="email"
                      {...register('email', {
                        required: 'Email is required',
                        pattern: {
                          value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                          message: "Invalid email address"
                        },
                      })}
                      placeholder="Email"
                    />
                  </div>
                  {getFormErrorMessage("email")}
                </div> */}
                                <div className="mb-3 col-12 mt-2">
                                    <Button
                                        type="button"
                                        className="btn btn-outline-dark mt-2"
                                        onClick={() => {
                                            navigate("/admin/pdf-upload")
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button className="btn btn-primary mt-2 ms-3" type="submit">
                                        Save
                                    </Button>
                                    <Button className="btn btn-dark mt-2 ms-3" onClick={handleTest} type="button">
                                        Test
                                    </Button>
                                </div>
                            </div>
                        </form>
                        :  <SharePointConnector selectedcity={selectedCity} keys={keys} loginKeys={loginKeys} handleChangeConnector={handleChangeConnector}/>
                        }
                    </div>
                </div>
            </div>
        </main>
    )
}

export default AddUpdateLoginPDF